import styled from 'styled-components';
import { Box } from '../../../../../../../../CommonComponents/OPL/Box/Box';
import { RawButton } from '../../../../../../../../CommonComponents/OPL/Button/Button.styles';

export const StatsRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  border: `1px solid ${theme.colors.neutral['200']}`,
  borderRadius: theme.radii.medium,
  overflow: 'hidden',
}));

export const StatItem = styled(RawButton)<{ isFocused?: boolean; isHidden?: boolean }>(
  ({ theme, isFocused, isHidden }) => ({
    flex: 1,
    display: 'flex',
    alignItems: 'flex-start',
    padding: `${theme.space['12']}px ${theme.space['16']}px`,
    borderRight: `1px solid ${theme.colors.neutral['200']}`,
    background: isHidden ? 'transparent' : isFocused ? theme.colors.neutral['50'] : 'transparent',
    cursor: 'pointer',
    userSelect: 'none',
    transition: 'opacity 0.2s ease, background 0.2s ease',
    opacity: isHidden ? 0.5 : 1,

    '&:last-child': {
      borderRight: 'none',
    },

    '&:hover': {
      background: theme.colors.neutral['50'],
    },
  }),
);

export const ColorBar = styled(Box)<{ bg: string }>(({ theme, bg }) => ({
  width: 4,
  minHeight: 44,
  borderRadius: theme.radii.small,
  background: bg,
  marginRight: 12,
  flexShrink: 0,
  transition: 'background 0.2s ease',
}));

export const LegendRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.space['24'],
  flexWrap: 'wrap',
  paddingTop: theme.space['8'],
}));

export const ClickableLegendItem = styled(RawButton)<{ isHidden?: boolean }>(
  ({ theme, isHidden }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.space['8'],
    cursor: 'pointer',
    userSelect: 'none',
    opacity: isHidden ? 0.45 : 1,
    transition: 'opacity 0.2s ease',

    '&:hover': {
      opacity: isHidden ? 0.65 : 0.8,
    },
  }),
);

export const LegendSwatch = styled(Box)<{ bg: string }>(({ theme, bg }) => ({
  width: 12,
  height: 12,
  borderRadius: theme.radii.small,
  background: bg,
  transition: 'background 0.2s ease',
}));
